import { apiRequestDev } from './apiRequest';

export const getAllCrimePoints = async (config) => apiRequestDev(config, '/crimes/points');